import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./backend/App";

const mainApp = document.getElementById("apwcf7-react-app");
if (mainApp) {
  createRoot(mainApp).render(
    <HashRouter>
      <App />
    </HashRouter>
  );
}